import { gql } from '@apollo/client';
import atlBidEventFragment from './atlBidEventFragment';

const ATL_BID_ON_EVENT = gql`
  mutation ATLBidOnEvent($eventId: Int!) {
    atlBidOnEvent(eventId: $eventId) {
      ...AtlBidEventFields
    }
  }
  ${atlBidEventFragment}
`;

export default ATL_BID_ON_EVENT;
